import React, {Component, ReactElement} from 'react'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {getQueryParameter, NatAsyncCallFunction} from '../../common/util/Natutil'
import NatEnvSettingRepo from '../envSetting/repository/NatEnvSettingRepo'
import NatSessionRepo from '../session/repository/NatSessionRepo'
import {AVAILABLE_SITE} from '../../../CodeMaster'
import {Messages} from '../../../Messages'
import MessageDialogComponent from '../../../common/resident/MessageDialogComponent'
import NatLoginRepo from '../login/repository/NatLoginRepo'
import {Location} from 'react-router-dom'
import NatResidentUserRepo, {
    CreateAuthorizeRequest,
    SetSeverSessionInfoRequest
} from '../residentUser/repository/NatResidentUserRepo';
import {NatSetServerSessionInfo} from '../residentUser/repository/NatSetServerSessionInfo';
import {NatCreateGenerateRequestParam} from '../residentUser/repository/NatCreateGenerateRequestParam';
import {NatCreateAuthorizeUrl} from '../residentUser/repository/NatCreateAuthorizeUrl';


const KEY_SSO_LOGIN_CONDOMINIUM_CD = 'ssoLoginCondominiumCd'
const KEY_SSO_LOGIN_RIDGE_CD = 'ssoLoginRidgeCd'
const KEY_SSO_LOGIN_ROOM_NUMBER = 'ssoLoginRoomNumber'
const KEY_SENI_URL = 'seniUrl'
const KEY_SENI_TYPE = 'seniType'
const SENI_TYPE_MYPAGE = 'seniTypeMypage'
const SENI_TYPE_OTHER = 'seniTypeOther'

interface Props {
    location: Location
    envSettingRepo: NatEnvSettingRepo
    sessionRepo: NatSessionRepo
    residentLoginRepo: NatLoginRepo
    residentUserRepo: NatResidentUserRepo,
}

interface State {
    backgroundLoginSite: AVAILABLE_SITE
    isOpenMultipleLoginWarningDialog: boolean
}

class NatResidentSsoLoginPage extends Component<Props & ResidentPagePropsSet, State> {

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)

        SessionStorageHelper.removeItem(KEY_SSO_LOGIN_CONDOMINIUM_CD)
        SessionStorageHelper.removeItem(KEY_SSO_LOGIN_RIDGE_CD)
        SessionStorageHelper.removeItem(KEY_SSO_LOGIN_ROOM_NUMBER)
        SessionStorageHelper.removeItem(KEY_SENI_URL)
        SessionStorageHelper.removeItem(KEY_SENI_TYPE)

        this.state = {
            backgroundLoginSite: AVAILABLE_SITE.NOT_LOGIN,
            isOpenMultipleLoginWarningDialog: false,
        }

        this.handleOkButtonClick = this.handleOkButtonClick.bind(this)
        this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const response = await NatAsyncCallFunction(
                this.props.sessionRepo.getLoginStatus.bind(this.props.sessionRepo),
                this.props.navigate,
            )
            if (response === null) {
                return
            }

            this.setState({
                backgroundLoginSite: AVAILABLE_SITE.codeToEnumConstants(response),
            })

            if (response === AVAILABLE_SITE.NOT_LOGIN.value) {
                await this.ssoLogin()
            } else {
                this.setState({
                    isOpenMultipleLoginWarningDialog: true,
                })
            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async ssoLogin(): Promise<void> {
        const isSutekiNetSmartPhoneApplication = SessionStorageHelper
            .getStringItemWithDefault('isSutekiNetSmartPhoneApplication', 'false')

        if (isSutekiNetSmartPhoneApplication === 'true') {
            const setSeverSessionInfoRequestSp: SetSeverSessionInfoRequest = {
                authenticationKey: null,
                ssoLoginCondominiumCd: null,
                ssoLoginRidgeCd: null,
                ssoLoginRoomNumber: null,
                loginPage: null,
                token: null,
                isSutekiNetSmartPhoneApplication: isSutekiNetSmartPhoneApplication
            };
            const retSp: Nullable<NatSetServerSessionInfo> =
                await NatAsyncCallFunction(this.props.residentUserRepo.setBackendSessionInfo.bind(
                        this.props.residentUserRepo, setSeverSessionInfoRequestSp),
                    this.props.navigate
                );
        }

        const ssoLoginCondominiumCd: string = getQueryParameter('condominiumCd', this.props.location.search)
        const ssoLoginRidgeCd: string = getQueryParameter('ridgeCd', this.props.location.search)
        const ssoLoginRoomNumber: string = getQueryParameter('roomNumber', this.props.location.search)
        const seniurl: string = getQueryParameter('seniurl', this.props.location.search)
        const seniType: string = seniurl ? SENI_TYPE_OTHER : SENI_TYPE_MYPAGE

        SessionStorageHelper.setItem(KEY_SSO_LOGIN_CONDOMINIUM_CD, ssoLoginCondominiumCd)
        SessionStorageHelper.setItem(KEY_SSO_LOGIN_RIDGE_CD, ssoLoginRidgeCd)
        SessionStorageHelper.setItem(KEY_SSO_LOGIN_ROOM_NUMBER, ssoLoginRoomNumber)
        SessionStorageHelper.setItem(KEY_SENI_URL, seniurl)
        SessionStorageHelper.setItem(KEY_SENI_TYPE, seniType)
        // 必要な情報をサーバのセッションに設定
        const setSeverSessionInfoRequest: SetSeverSessionInfoRequest = {
            authenticationKey: '',
            ssoLoginCondominiumCd: ssoLoginCondominiumCd,
            ssoLoginRidgeCd: ssoLoginRidgeCd,
            ssoLoginRoomNumber: ssoLoginRoomNumber,
            loginPage: 'NatResidentSsoLoginPage',
            token: '',
            isSutekiNetSmartPhoneApplication: null
        };

        const ret: Nullable<NatSetServerSessionInfo> =
            await NatAsyncCallFunction(this.props.residentUserRepo.setBackendSessionInfo.bind(
                    this.props.residentUserRepo, setSeverSessionInfoRequest),
                this.props.navigate
            );
        if (ret) {
            // ログイン認証
            // ステート、ノンス取得し、セッションへ格納
            const createGenerateRequestParam: Nullable<NatCreateGenerateRequestParam> =
                await NatAsyncCallFunction(
                    this.props.residentUserRepo.createGenerateRequestParam.bind(
                        this.props.residentUserRepo), this.props.navigate);
            if (createGenerateRequestParam) {
                // パラメータ作成
                const createAuthorizeRequest: CreateAuthorizeRequest = {
                    mailAddress: null,
                };
                const natCreateAuthorizeUrl: Nullable<NatCreateAuthorizeUrl> =
                    await NatAsyncCallFunction(
                        this.props.residentUserRepo.createAuthorize.bind(
                            this.props.residentUserRepo, createAuthorizeRequest), this.props.navigate);
                if (natCreateAuthorizeUrl && natCreateAuthorizeUrl.details) {
                    window.location.href = natCreateAuthorizeUrl.details;
                }
            }
        }
    }

    async logoutProcedure(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            await NatAsyncCallFunction(this.props.residentLoginRepo.postLogout.bind(
                this.props.residentLoginRepo,
            ), this.props.navigate)
            await NatAsyncCallFunction(this.props.sessionRepo.postResidentUseSite.bind(
                this.props.sessionRepo,
            ), this.props.navigate)
            SessionStorageHelper.removeAllItem()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleOkButtonClick(): Promise<void> {
        this.setState({isOpenMultipleLoginWarningDialog: false})
        await this.logoutProcedure()
        await this.ssoLogin()
    }

    handleCancelButtonClick(): void {
        this.setState({isOpenMultipleLoginWarningDialog: false})
        this.props.navigate('/resident/login', {replace: true})
    }

    renderMultipleLoginWarningDialog(
        backgroundLoginSite: AVAILABLE_SITE,
        isOpenMultipleLoginWarningDialog: boolean,
    ): Nullable<ReactElement> {
        let multipleLoginWarningDialogMessage
        if (backgroundLoginSite === AVAILABLE_SITE.ADMIN) {
            multipleLoginWarningDialogMessage = Messages.WOPCR0001
        } else if (backgroundLoginSite === AVAILABLE_SITE.RESIDENT) {
            multipleLoginWarningDialogMessage = Messages.WOPCR0002
        } else if (backgroundLoginSite === AVAILABLE_SITE.GUEST) {
            multipleLoginWarningDialogMessage = Messages.WOPCR0004
        } else {
            return null
        }

        return <MessageDialogComponent
            open={isOpenMultipleLoginWarningDialog}
            params={{
                title: '確認',
                errorLevel: multipleLoginWarningDialogMessage.errorLevel,
                message: multipleLoginWarningDialogMessage.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleCancelButtonClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleOkButtonClick,
                    },
                ],
            }}
        />
    }

    render(): Nullable<ReactElement> {
        return this.renderMultipleLoginWarningDialog(
            this.state.backgroundLoginSite,
            this.state.isOpenMultipleLoginWarningDialog,
        )
    }
}

export default createResidentPage(NatResidentSsoLoginPage)
